export { default } from './GenericBanner'
